
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'CancelOfferAnnual',
    props: { claiming: { type: Boolean, default: false } },
    emits: ['claim', 'decline', 'stay'],
});
